import LineReceptionContainers from '../../containers/lineReception/lineReceptionContainer';

function LineReceptionMain(props) {
  const {
    selectCustomer,
    page,
    setPage,
    rowsPerPage,
    setRowPages,
    selectedUserId,
  } = props;

  return (
    <div>
      <LineReceptionContainers
        selectCustomer={selectCustomer}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowPages={setRowPages}
        selectedUserId={selectedUserId}
      />
    </div>
  );
}

export default LineReceptionMain;
